import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6283bbd7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-is-open", "content"]

import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import Icon from '@/components/ui/Icon.vue';
import ChecklistsPopoverContent from '@/components/checklists/ChecklistsPopoverContent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistsNavButton',
  setup(__props) {

const store = useStore();

const isOpen = computed(() => store.getters['checklists/popoverOpen']);

const url = new URL(window.location.href);
const isOnboarding = url.searchParams.has('onboarding');

const timeout = ref<number | null>(null);

onMounted(() => {
  if (isOnboarding) {
    timeout.value = setTimeout(() => {
      store.commit('checklists/setPopoverOpen', true);
    }, 10000);
  }
});

function toggleChecklists() {
  if (timeout.value) {
    clearTimeout(timeout.value);
  }

  store.commit('checklists/setPopoverOpen', !isOpen.value);
}

function onClose() {
  store.commit('checklists/setPopoverOpen', false);
}

const tooltipContent = computed(() => {
  const steps = store.getters['checklists/steps'];

  const progress = steps.filter((step) => !!step.completed_at).length / steps.length;

  return `${(progress * 100).toFixed(0)}% completed`;
});


return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      id: "checklists-nav-button",
      class: _normalizeClass([
      'cursor-pointer hover:opacity-80 h-10 w-10 rounded-full flex items-center justify-center shadow-[0_4px_12px_0_rgba(0,0,0,0.08)]',
      {
        'opacity-80': _unref(isOpen) && !_unref(isOnboarding),
        'animate-pulse': _unref(isOnboarding)
      }
    ]),
      "data-is-open": _unref(isOpen),
      content: _unref(tooltipContent),
      onClick: toggleChecklists
    }, [
      _createVNode(Icon, {
        class: "text-inherit w-4 h-4",
        type: "bulb"
      })
    ], 10, _hoisted_1)), [
      [_directive_tippy]
    ]),
    (_unref(isOpen))
      ? (_openBlock(), _createBlock(ChecklistsPopoverContent, {
          key: 0,
          "on-close": onClose
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})